import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/navbar.tsx';
import Homepage from './pages/homepage.tsx';
import Servizi from './pages/servizi.tsx';
import Prodotti from './pages/prodotti.tsx';
import Contatti from './pages/contatti.tsx';
import NotFound from './pages/notfound.tsx';
import Accessibilita from './pages/accessibilita.tsx';
import TrasparenzaIA from './pages/trasparenza-ia.tsx';
import PrivacyPolicy from './pages/privacy-policy.tsx';
import CookiePolicy from './pages/cookie-policy.tsx';
import Footer from './components/footer/footer.tsx';
import CookieBanner from './components/cookie-banner/CookieBanner.tsx';
import { TransitionProvider } from './context/TransitionContext.tsx';

import './styles/global.scss';

function App() {
  return (
    <div className="App" style={{ position: 'relative' }}>
      <Router>
        <TransitionProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/accessibilita" element={<Accessibilita />} />
            <Route path="/trasparenza-ia" element={<TrasparenzaIA />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </TransitionProvider>
      </Router>
    </div>
  );
}

export default App;
